import React from 'react';
import { User } from '../types';

interface RoleBadgeProps {
  role: User['role'];
}

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  const getRoleConfig = (role: User['role']) => {
    switch (role) {
      case 'admin':
        return { label: 'Admin', className: 'bg-red-100 text-red-800' };
      case 'content_editor':
        return { label: 'Editor', className: 'bg-teal-100 text-teal-800' };
      case 'analyst':
        return { label: 'Analyst', className: 'bg-blue-100 text-blue-800' };
      default:
        return { label: 'User', className: 'bg-gray-100 text-gray-800' };
    }
  };

  const config = getRoleConfig(role);

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
};